import { Tema } from "./tema";

export class Materia {
  id: number;
  idTema: number;
  tema: Tema;
  titulo: string;
  imagemDestaque: string;
  classeImagem: string;
  texto: string;
  resumo: string;
  fonte: string;
  ativo: boolean;
  permiteComentario:boolean;
  data: Date;
}
